import ConvertSDK from '@convertcom/js-sdk';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { CONVERT_ACCOUNT_ID, CONVERT_FULLSTACK_PROJECT_ID },
  // eslint-disable-next-line local-rules/no-top-level-getconfig
} = getConfig();

const sdkConfig = {
  sdkKey: `${CONVERT_ACCOUNT_ID}/${CONVERT_FULLSTACK_PROJECT_ID}`,
  environment: 'production',
};

const convertSdk = new ConvertSDK(sdkConfig);

export default convertSdk;
